import produce from 'immer';
import { types, SalesErrorState, SalesErrorActionTypes, SetError } from './types';

export const actions = {
  setError: (payload: SalesErrorState) => ({ type: types.SET_ERROR, payload }),
  resetError: () => ({ type: types.RESET_ERROR })
};

export const initialState: SalesErrorState = {
  error: undefined,
  additionalInfo: undefined,
  type: undefined
};

/**
 * Global error handler for the sales (customer facing) flows.
 */
export const reducer = (state: SalesErrorState = initialState, action: SalesErrorActionTypes): SalesErrorState => {
  // eslint-disable-next-line consistent-return
  return produce(state, draft => {
    switch (action.type) {
      case types.SET_ERROR:
        draft.error = (action as SetError).payload.error;
        draft.additionalInfo = (action as SetError).payload.additionalInfo;
        draft.type = (action as SetError).payload.type;
        break;
      case types.RESET_ERROR:
        return initialState;
      default:
    }
  });
};
